import Model from "./model";
import ApiSlackIntegration from "../api/model/integrations/barrel/SlackIntegration";
import IncomingWebHook from "../api/model/integrations/barrel/IncomingWebhook";

class SlackIntegration extends Model {
    id: string;
    _id: string;
    teamName: string;
    teamId: string;
    scope: string;
    incomingWebHook: IncomingWebHook;

    constructor(slackIntegrationData: ApiSlackIntegration) {
        super();

        const {
            _id,
            teamName,
            teamId,
            scope,
            incomingWebHook
        } = slackIntegrationData;

        this._id = _id;
        this.id = _id;
        this.teamName = teamName;
        this.teamId = teamId;
        this.scope = scope;
        this.incomingWebHook = incomingWebHook;
    }
}

export default SlackIntegration;
